import companyFormModel from "./companyFormModel";
import multipleNSAFormInitialValue from "./multipleNSAFormInitialValue";

const formField = companyFormModel.formField;


export default {
    /******************
     * Business Details
     *****************/
    [formField.current_customer.name]: "",
    [formField.account_no.name]: "",
    [formField.current_mobile_no.name]: "",
    [formField.company_name.name]: "",
    [formField.trading_as.name]: "",
    [formField.abn_acn.name]: "",
    [formField.industry_type.name]: "",
    [formField.account_pin.name]: "",
    [formField.business_type.name]: "",
    [formField.trading_start_date.name]: new Date(),
    [formField.director_name.name]: "",
    [formField.time_in_industry.fields.industry_years.name]: "",
    [formField.time_in_industry.fields.industry_months.name]: "",
    [formField.no_of_employees.name]: "",
    [formField.no_of_locations.name]: "",
    [formField.current_trading_address.fields.street.name]: "",
    [formField.current_trading_address.fields.state.name]: "",
    [formField.current_trading_address.fields.postcode.name]: "",
    [formField.time_at_current_address.fields.current_trading_address_years.name]: "",
    [formField.time_at_current_address.fields.current_trading_address_months.name]: "",
    [formField.previous_trading_address.fields.street.name]: "",
    [formField.previous_trading_address.fields.state.name]: "",
    [formField.previous_trading_address.fields.postcode.name]: "",
    /******************
     * Customer Details form
     *****************/
    [formField.customer_type.name]: "",
    [formField.title.name]: "",
    [formField.given_name.name]: "",
    [formField.surname.name]: "",
    [formField.position_in_company.name]: "",
    [formField.date_of_birth.name]: new Date(),
    [formField.email.name]: "",
    [formField.primary_contact_no.name]: "",
    [formField.customer_contact_address.fields.street.name]: "",
    [formField.customer_contact_address.fields.state.name]: "",
    [formField.customer_contact_address.fields.postcode.name]: "",
    [formField.id1_type.name]: "",
    [formField.id1_ref_no.name]: "",
    [formField.id1_expiry_date.name]: new Date(),
    [formField.id2_type.name]: "",
    [formField.id2_ref_no.name]: "",
    [formField.id2_expiry_date.name]: new Date(),
    [formField.id1a_file.name]: "",
    [formField.id1b_file.name]: "",
    [formField.id2_file.name]: "",
    /******************
     * Billing Account Details
     *****************/
    [formField.send_email_bill.name]: false,
    [formField.bill_email.name]: "",
    [formField.send_paper_bill.name]: false,
    [formField.billing_address.fields.street.name]: "",
    [formField.billing_address.fields.state.name]: "",
    [formField.billing_address.fields.postcode.name]: "",
    [formField.view_bill_online.name]: false,
    [formField.debit_from_bank.name]: false,
    [formField.bank_bsb_no.name]: "",
    [formField.bank_acct_no.name]: "",
    [formField.bank_institution.name]: "",
    [formField.bank_acct_name.name]: "",
    [formField.debit_from_card.name]: false,
    [formField.card_type.name]: "",
    [formField.card_number.name]: "",
    [formField.cardholder_name.name]: "",
    [formField.card_expiry_date.name]: new Date(),
    /******************
     * Are you aware form
     *****************/
    [formField.application_agreement.fields.approval.name]: false,
    [formField.application_agreement.fields.application_by_me.name]: false,
    [formField.application_agreement.fields.governed_by_terms.name]: false,
    [formField.application_agreement.fields.application_for_purchase.name]: false,
    [formField.application_agreement.fields.allow_credit_check.name]: false,
    [formField.application_agreement.fields.min_commitment_period.name]: false,
    [formField.application_agreement.fields.responsible_for_due.name]: false,
    [formField.application_agreement.fields.company_authorized.name]: false,
    [formField.plan_critical_info.fields.plan_explained.name]: false,
    [formField.contract_term.fields.term_charge_explained.name]: false,
    [formField.network_coverage.fields.coverage_understood.name]: false,
    [formField.network_coverage.fields.any_network.name]: false,
    [formField.handset_insurance.fields.handset_insurance_offered.name]: false,
    [formField.aware_devices.fields.devices_provided.name]: false,
    [formField.aware_devices.fields.devices_deferred.name]: false,
    [formField.aware_porting.fields.porting_yes.name]: false,
    [formField.aware_porting.fields.porting_date.name]: false,
    [formField.international_roaming.fields.new_active_default.name]: false,
    [formField.international_roaming.fields.old_unchanged.name]: false,
    [formField.direct_debit_request.fields.account_authorized.name]: false,
    [formField.direct_debit_request.fields.can_cancel_debit.name]: false,
    [formField.direct_debit_request.fields.corp_card_authorized.name]: false,
    [formField.aware_privacy.fields.privacy_accepted.name]: false,
    [formField.aware_billing.fields.payment_terms_explained.name]: false,
    /******************
     * Authorised Signatories Form
     *****************/
    [formField.customer_signature_date.name]: new Date(),
    [formField.billing_acct_no.name]: "",
    [formField.representative_signature.name]: "",
    [formField.representative_signature_date.name]: new Date(),
    /******************
     * Multiple NSA Form
     *****************/
    [formField.total_no_services.name]: "",
    [formField.directory_listed.name]: false,
    [formField.multiple_services_enabled.name]: false,
    ...multipleNSAFormInitialValue,
    /******************
     * Customer Understanding Form
     *****************/
    [formField.hardware_allowance.name]: "",
    [formField.hardware_ordered.name]: "",
    [formField.data_allowance.name]: "",
    [formField.international_calling_allowance.fields.zone_1.name]: "",
    [formField.international_calling_allowance.fields.zone_2.name]: "",
    [formField.minimum_monthly_commitment.name]: "",
    [formField.payout_amount.name]: "",
    [formField.non_standard_offer.name]: "",
    [formField.cuf_approved_by.name]: "",
    [formField.cuf_approve_signed.name]: "",
    [formField.cuf_approve_date.name]: new Date(),
    [formField.cuf_sign_date.name]: new Date()
};